import { validationRules} from "components/Form";
import {FormattedMessage} from "react-intl";
import { TLoginFields } from "./Login.types";


export const loginFields:TLoginFields = {
    email: {
        name: 'username',
        label: 'login.form.emailLabel',
        rules: [
            { required: true, message: <FormattedMessage id="login.form.emailRequired" />},
            {
                validator(_: any, value: string) {
                    if (!value) return Promise.resolve();
                    const trimmed = value.trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(trimmed)) return Promise.resolve();
                    return Promise.reject(new Error(''));
                },
                message: <FormattedMessage id="login.form.incorrectEmail" />,
            },
        ],
        placeholder: 'login.form.emailPlaceholder',
    },
    password: {
        name: 'password',
        label: 'login.form.passwordLabel',
        rules: [
            ...validationRules.password,
            validationRules.required('password'),
            validationRules.withoutSpace('Password'),
        ],
        placeholder: 'login.form.passwordPlaceholder',
    },
};